import mainOverrides from '^/utils/mainOverrides'
import MobileHomePageCategories from 'vue-src/top-level/mobile-home-page-categories'
function revolutionSliderTest(){
  return (mainOverrides.revolutionSliderTest() && window.innerWidth > 992 )
}

function extraComponents({Vue, store, inits}, position){
  if(position===0 &&
      document.querySelectorAll('#mobile-jedco-simple-home').length === 1){
    inits.push('jedco-mobile-home-page');
    new Vue({
      el:"#mobile-jedco-simple-home",
      store,
      render(e){
        return e(MobileHomePageCategories);
      },
    })
  }
}

export default {
  ...mainOverrides,
  revolutionSliderTest,
  extraComponents
}


// WEBPACK FOOTER //
// ./ixcms/themes/jedco/src/vue-src/utils/mainOverrides.js